<template>
  <div class="cpv-search-block padding-b-20 padding-r-10 padding-t-10 padding-l-10 d-flex justify-content-center">
    <div class="search-input-block">
      <input
          v-model="searchQuery"
          id="search"
          class="cpv-search d-block"
          placeholder="Որոնել"
          type="text"
      >
      <img @click="handleSearch" class="search" src="/assets/landing/images/Search.svg" alt="search">
    </div>
  </div>
</template>

<script>
    export default {
      name: 'SearchInput',
      data() {
        return {
          searchQuery: ''
        }
      },
      methods: {
        handleSearch(){
          this.$emit('handleSearch', this.searchQuery);
        },
      }
    }
</script>
<style scoped>
.cpv-search-block{
  flex: 0 0 auto;
  width: fit-content;
  max-width: 100%;

  .search-input-block{
    position: relative;

    .cpv-search{
      height: 36px;
      width: 365px;
    }
    .search{
      position: absolute;
      top: 0;
      bottom: 0;
      right: 15px;
      margin: auto !important;
    }
  }
}
@media (max-width: 1024px) {
  .cpv-search-block{
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .cpv-search, .search-input-block{
    width: 100% !important;
  }
}
</style>
